import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Shield, Calendar, ArrowLeft, Wallet } from "lucide-react";

export default function CaptainDashboard() {
  const [jobs, setJobs] = useState(null);

  useEffect(() => {
    api.get("/captain/jobs").then(({ data }) => setJobs(data)).catch(() => setJobs([]));
  }, []);

  if (!jobs) return <div className="p-12 text-center text-muted-foreground">Loading…</div>;

  const active = jobs.filter(j => !["completed", "cancelled"].includes(j.status));
  const past = jobs.filter(j => ["completed", "cancelled"].includes(j.status));

  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-8">
      <Link to="/dashboard" className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-brand mb-6">
        <ArrowLeft className="w-4 h-4" /> Back to dashboard
      </Link>

      <div className="flex items-center gap-2 mb-1">
        <Shield className="w-6 h-6 text-brand" />
        <h1 className="font-display text-3xl tracking-tighter">Captain duties</h1>
      </div>
      <p className="text-sm text-muted-foreground mb-6">Roles you're captaining — generate QR codes and mark attendance.</p>

      {active.length === 0 ? (
        <div className="card-flat text-center py-12">
          <Shield className="w-10 h-10 text-muted-foreground mx-auto mb-3" />
          <p className="font-display text-xl">No active assignments</p>
          <p className="text-sm text-muted-foreground mt-1">You'll see roles here once a manager adds you as captain.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {active.map(j => (
            <Link key={j.id} to={`/manage/${j.id}`} className="card-flat block hover:border-brand transition">
              <div className="flex items-center justify-between gap-3 flex-wrap">
                <div>
                  <p className="font-medium text-foreground">{j.title}</p>
                  <p className="text-xs text-muted-foreground">{j.specialization}</p>
                </div>
                <div className="flex items-center gap-3 text-xs flex-wrap">
                  {j.event_date && (
                    <span className="flex items-center gap-1 text-muted-foreground">
                      <Calendar className="w-3.5 h-3.5" />
                      {new Date(j.event_date).toLocaleDateString("en-IN", { day: "numeric", month: "short" })}
                    </span>
                  )}
                  {j.can_mark_payment && (
                    <span className="flex items-center gap-1 text-emerald-600 font-medium">
                      <Wallet className="w-3.5 h-3.5" /> Payments
                    </span>
                  )}
                  <span className="text-brand font-medium">Manage →</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}

      {past.length > 0 && (
        <div className="mt-8">
          <h2 className="font-display text-lg mb-3 text-muted-foreground">Past assignments ({past.length})</h2>
          <div className="space-y-2 opacity-70">
            {past.map(j => (
              <div key={j.id} className="card-flat flex items-center justify-between gap-3 flex-wrap">
                <div>
                  <p className="font-medium text-foreground">{j.title}</p>
                  <p className="text-xs text-muted-foreground">{j.specialization}</p>
                </div>
                <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-muted text-muted-foreground">{j.status}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}